import {
    Box,
    FormControl,
    Paper,
    RadioGroup,
    Typography,
    FormControlLabel,
    Radio,
    createTheme,
    ThemeProvider,
    Button,
    Rating,
} from '@mui/material';
import { useEffect, useState } from 'react';
import axios from 'axios';
import { configState } from '../lib/State';
import get_cid from '../lib/get_cid';
import Swal from 'sweetalert2';

const radiofontTheme = createTheme({
    components: {
        MuiTypography: {
            styleOverrides: {
                root: {
                    fontSize: '12px'
                }
            }
        },
        MuiFormControlLabel: {
            styleOverrides: {
                root: {
                    marginLeft: '2px',
                    marginRight: '2px'
                }
            }
        },
    }
})

const starTheme = createTheme({
    components: {
        MuiRating: {
            styleOverrides: {
                label: {
                    padding: '5px 3px',
                    fontSize: '28px',
                }
            }
        }
    }
})


function RatingClass(params) {
    const { seq, classname, tname, tcd, login, coupon_seq, closeClick } = params;
    const [value, setValue] = useState(0);
    const [satisfaction, setSatisfaction] = useState('');
    const [kindness, setKindness] = useState('');
    const [faithful, setFaithful] = useState('');
    const [credibility, setCredibility] = useState('');
    const [interest, setInterest] = useState('');
    const [category, setCategory] = useState('');
    const [comment, setComment] = useState('');
    const token = localStorage.getItem("token");
    const cid = get_cid();
    const labels = [
        {id: 0, label: '별점 선택'},
        {id: 1, label: '1점'},
        {id: 2, label: '2점'},
        {id: 3, label: '3점'},
        {id: 4, label: '4점'},
        {id: 5, label: '5점'},
    ]

    console.log(coupon_seq)

    const load_data = async () => {
        let result = await axios.post(configState.api + "/gympass/rating_list", {
            token: token,
            cid: cid,
            mcd: login.mcd,
            level: login.level,
            coupon_seq: coupon_seq,
        });
        if (result.data.success === 1) {
            setCategory(result.data.category);
            setComment(result.data.comment);
        }
    }

    useEffect(() => {
        load_data();
    }, []);

    const onSubmit = async() => {
        let result = await axios.post(configState.api + '/gympass/rating_add', {
            token: token,
            cid: cid,
            level: login.level,
            mcd: login.mcd,
            res_seq: seq,
            tcd: tcd,
            rating: value,
            category: category,
            // coupon_seq: coupon_seq,
        });
        if(result.data.success !== 1) {
            Swal.fire(result.data.msg)
        } else {
            Swal.fire({ title: '강사평가가 제출되었습니다. 50캐시 적립되었습니다.', showCloseButton: true}).then(
                (result) => {
                    closeClick()
                }
            )
        }
    }

    return (
        <Box>
            <Box
                sx={{
                    margin: '20px 10px'
                }}>
                <span style={{ fontWeight: 'bold' }}>{classname}</span><span> 수업의 <span style={{ fontWeight: 'bold' }}>{tname}</span> 강사님에 관한 설문입니다.</span>
                <Box
                    sx={{
                        marginTop: '20px',
                        marginBottom: '20px'
                    }}>
                    <Paper
                        elevation={3}
                        sx={{
                            padding: '10px',
                            background: '#EBEBEB'
                        }}>
                        <Box
                            sx={{
                                fontSize: '14px',
                                textAlign: 'center',
                            }}>
                            {comment}
                        </Box>
                        <Box
                            sx={{
                                width: '100%',
                                display: 'flex',
                                justifyContent: 'center',
                            }}>
                        <Box
                            sx={{
                                display: 'flex',
                                // flexDirection: 'column',
                                justifyContent: 'center',
                                alignItems: 'center',
                                width: '80%'
                            }}>
                            <ThemeProvider theme={starTheme}>
                                <Rating
                                    value={value}
                                    onChange={(e, newValue) => {
                                        setValue(newValue);
                                    }}
                                />
                            </ThemeProvider>
                            <Box>
                                {labels.map((item, idx) => {
                                    // let temp = labels;
                                    // temp = temp.filter((el) => el.id === value);
                                    return (
                                        <Box
                                            sx={{
                                                fontSize: '14px'
                                            }}>
                                            {item.id === value && item.label}
                                        </Box>
                                    )
                                })}
                            </Box>
                            </Box>
                        </Box>
                        {/* <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'center'
                            }}>
                            <FormControl>
                                <RadioGroup
                                    row
                                    value={value}
                                    onChange={(e) => setValue(e.target.value)}>
                                    <ThemeProvider theme={radiofontTheme}>
                                        <FormControlLabel
                                            value={1}
                                            control={<Radio />}
                                            label='1점'
                                            labelPlacement='bottom'
                                        />
                                        <FormControlLabel
                                            value={2}
                                            control={<Radio />}
                                            label='2점'
                                            labelPlacement='bottom'
                                        />
                                        <FormControlLabel
                                            value={3}
                                            control={<Radio />}
                                            label='3점'
                                            labelPlacement='bottom'
                                        />
                                        <FormControlLabel
                                            value={4}
                                            control={<Radio />}
                                            label='4점'
                                            labelPlacement='bottom'
                                        />
                                        <FormControlLabel
                                            value={5}
                                            control={<Radio />}
                                            label='5점'
                                            labelPlacement='bottom'
                                        />
                                    </ThemeProvider>
                                </RadioGroup>
                            </FormControl>
                        </Box> */}
                    </Paper>
                </Box>

            </Box>
            <Button
                variant='contained'
                sx={{
                    width: '100%',
                    borderRadius: 0,
                    background: '#DE3A7B',
                    marginTop: '20px',
                    fontSize: '15px'
                }}
                onClick={onSubmit}
            >
                평가 제출
            </Button>
        </Box>
    )
}

export default RatingClass;